import { defer, from, Observable } from 'rxjs';

export class ClipboardTools {
  /**
   * Reading and writing both reach the api at subscription rather than at call time: on a browser or
   * a context without `navigator.clipboard` the property access itself throws, and eagerly it would
   * throw past the subscriber instead of reaching its error callback.
   */
  public static copyText(text: string): Observable<void> {
    return defer(() => from(navigator.clipboard.writeText(text)));
  }

  public static readText(): Observable<string> {
    return defer(() => from(navigator.clipboard.readText()));
  }
}
